(function () {
  var rawPath = window.location.pathname || '/';
  var localeMatch = /^\/(cs|sk)(?=\/|$)/i.exec(rawPath);
  var localePrefix = localeMatch ? '/' + localeMatch[1].toLowerCase() : '';
  var localeRoot = localePrefix ? localePrefix + '/' : '/';
  var path = rawPath.replace(/^\/(cs|sk)(?=\/|$)/i, '') || '/';

  function stockLabel(value) {
    var count = Number(value || 0);
    if (count > 10) return 'dużo';
    if (count >= 5) return 'końcówka';
    if (count > 0) return 'ostatnie sztuki';
    return 'niedostępne';
  }

  function marketScannerUrl(withHash) {
    var suffix = withHash || '';
    if (localePrefix === '/cs' || /\.cz$/i.test(window.location.hostname)) return 'https://footballmasters.cz/cs/pages/pomiar' + suffix;
    if (localePrefix === '/sk' || /\.sk$/i.test(window.location.hostname)) return 'https://footballmasters.sk/sk/pages/pomiar' + suffix;
    return localeRoot.replace(/\/$/, '') + '/pages/pomiar' + suffix;
  }

  function localScannerQrAssetUrl() {
    var existing = document.querySelector('img[src*="fm-scanner-qr"]');
    if (existing && existing.src) return existing.src;

    var assetSource = document.querySelector('script[src*="/assets/fm-storefront-launch-excellence.js"], link[href*="/assets/critical.css"]');
    var sourceUrl = assetSource && (assetSource.src || assetSource.href);
    if (!sourceUrl || sourceUrl.indexOf('/assets/') === -1) return '';

    var base = sourceUrl.split('/assets/')[0] + '/assets/fm-scanner-qr.svg';
    var version = /[?&]v=([^&]+)/.exec(sourceUrl);
    return version ? base + '?v=' + version[1] : base;
  }

  function qrImageUrl(targetUrl) {
    if (/footballmasters\.(cz|sk)/i.test(targetUrl || '')) {
      return 'https://api.qrserver.com/v1/create-qr-code/?size=132x132&data=' + encodeURIComponent(targetUrl);
    }
    return localScannerQrAssetUrl() || ('https://api.qrserver.com/v1/create-qr-code/?size=132x132&data=' + encodeURIComponent(targetUrl));
  }

  function previewLocale() {
    try {
      var url = new URL(window.location.href);
      var view = (url.searchParams.get('view') || '').toLowerCase();
      if (view === 'cs' || /^\/cs(\/|$)/i.test(window.location.pathname) || /\.cz$/i.test(window.location.hostname)) return 'cs';
      if (view === 'sk' || /^\/sk(\/|$)/i.test(window.location.pathname) || /\.sk$/i.test(window.location.hostname)) return 'sk';
    } catch (error) {}
    return '';
  }

  function applyPreviewLocale() {
    var locale = previewLocale();
    if (locale === 'cs' || locale === 'sk') return;
    if (locale !== 'cs') return;

    document.documentElement.lang = 'cs';

    var exact = {
      'Darmowa wysyłka od 349 zł / 89 €': 'Doprava zdarma od 1 750 Kč',
      '🚚 Darmowa wysyłka od 349 zł / 89 €': '🚚 Doprava zdarma od 1 750 Kč',
      'Darmowa wysyłka od 300 zł / 70 €': 'Doprava zdarma od 1 750 Kč',
      '🚚 Darmowa wysyłka od 300 zł / 70 €': '🚚 Doprava zdarma od 1 750 Kč',
      'Football Masters': 'Football Masters',
      'rękawice bramkarskie · od 2014': 'brankářské rukavice · od roku 2014',
      'Sklep': 'Obchod',
      'Modele': 'Modely',
      'Porównaj': 'Porovnat',
      'Pomoc w wyborze': 'Pomoc s výběrem',
      '★ FM Team': '★ FM Team',
      'Dobierz rozmiar': 'Vybrat velikost',
      'Dla klubów': 'Pro kluby',
      'Koszyk': 'Košík',
      'Moje konto': 'Můj účet',
      'Język sklepu': 'Jazyk obchodu',
      'Polski': 'Polski',
      'Čeština': 'Čeština',
      'wysyłka 24h': 'odeslání do 24 h',
      '⚡ wysyłka 24h': '⚡ odeslání do 24 h',
      '14 dni zwrot': '14 dní na vrácení',
      '↩ 14 dni zwrot': '↩ 14 dní na vrácení',
      'bezpieczny checkout': 'bezpečná platba',
      'Stripe SSL': 'Stripe SSL',
      'Polski producent od 2014': 'Polská značka od roku 2014',
      '🇵🇱 Polski producent od 2014': '🇨🇿 CZ · FM od 2014',
      'polska marka od 2014': 'polská značka od roku 2014',
      'Varis · krój Negative': 'Varis · střih Negative',
      'Polska marka od 2014': 'Polská značka od roku 2014',
      'Football Masters': 'Football Masters',
      'Czucie piłki.': 'Cit pro míč.',
      'Kup w sklepie': 'Koupit v obchodě',
      'Zobacz modele': 'Zobrazit modely',
      'Invictus · krój Roll Finger+': 'Invictus · střih Roll Finger+',
      'Stabilizacja.': 'Stabilita.',
      'Kup rękawice': 'Koupit rukavice',
      'Porównaj modele': 'Porovnat modely',
      'Najważniejsze informacje przed zakupem': 'Nejdůležitější informace před nákupem',
      'Wysyłka 24h': 'Odeslání do 24 h',
      'DHL / InPost do 12:00 = dzisiaj': 'Objednávky do 12:00 připravujeme tentýž den',
      'Zgodnie z regulaminem sklepu': 'Podle pravidel obchodu',
      'Oficjalny sklep': 'Oficiální obchod',
      'Football Masters od 2014': 'Football Masters od roku 2014',
      'Opinie klientów Football Masters': 'Hodnocení zákazníků Football Masters',
      '1% dla klimatu': '1 % pro klima',
      'Stripe Climate · carbon removal EU': 'Stripe Climate · odstraňování uhlíku v EU',
      'Dowody zaufania Football Masters': 'Důvody důvěřovat Football Masters',
      'Bramkarzy zaufało FM': 'brankářů důvěřovalo FM',
      'Opinie klientów': 'Hodnocení zákazníků',
      'Klubów i akademii B2B': 'klubů a akademií B2B',
      'Sklep marki Football Masters': 'obchod značky Football Masters',
      'Marka z Janków koło Warszawy': 'značka z Janek u Varšavy',
      'Tylko na fm.pro · pierwsi w EU': 'Jen na FM Pro · první v EU',
      'Zmierz dłoń kamerą. 10 sekund.': 'Změř ruku kamerou. 10 sekund.',
      'Szerokość dłoni': 'Šířka ruky',
      'Długość dłoni': 'Délka ruky',
      'Styl gry': 'Styl hry',
      'Czucie piłki i szybka reakcja': 'Cit pro míč a rychlá reakce',
      'Stabilizacja i pełniejsze osadzenie': 'Stabilita a pevnější usazení',
      'Codzienny trening': 'Každodenní trénink',
      'Rekomendacja': 'Doporučení',
      'Przejdź do rekomendowanych': 'Přejít na doporučené',
      'Skaner dłoni': 'Skener ruky',
      'Zaufanie': 'Důvěra',
      'Dowody, które pomagają wybrać.': 'Důkazy, které pomáhají vybrat.',
      'Dlaczego FM Pro': 'Proč FM Pro',
      'Chwyt meczowy. Bez zgadywania.': 'Zápasový grip. Bez hádání.',
      'Top wybór bramkarzy': 'Top volba brankářů',
      'Varis, Invictus, Junior i Training.': 'Varis, Invictus, Junior a Training.',
      'Najważniejsze modele': 'Nejdůležitější modely',
      'Top wybór bramkarzy.': 'Top volba brankářů.',
      'Przejdź do sklepu': 'Přejít do obchodu',
      'W magazynie': 'Skladem',
      'Wyprzedane': 'Vyprodáno',
      'Wybierz model pod styl gry.': 'Vyber model podle stylu hry.',
      'Wybierz model i przejdź do sklepu.': 'Vyber model a přejdi do obchodu.',
      'Zapytanie klubowe': 'Dotaz pro klub',
      'Dane firmy': 'Údaje firmy',
      'Obsługa': 'Obsluha',
      'Regulamin': 'Obchodní podmínky',
      'Dostawa': 'Doprava',
      'Zwroty i reklamacje': 'Vrácení a reklamace',
      'Prywatność i cookies': 'Soukromí a cookies'
    };

    var patterns = [
      [/Zgody na pliki cookie/g, 'Souhlas s cookies'],
      [/Football Masters Pro i partnerzy technologiczni, w tym Shopify, używają plików cookie do działania sklepu, personalizacji, analityki i reklam\. Opcjonalnych cookie użyjemy tylko po Twojej zgodzie\. Szczegóły znajdziesz w naszej/g, 'Football Masters Pro a technologičtí partneři, včetně Shopify, používají cookies pro fungování obchodu, personalizaci, analytiku a reklamu. Volitelné cookies použijeme jen po vašem souhlasu. Podrobnosti najdete v našich'],
      [/Ustawienia zgód/g, 'Nastavení souhlasů'],
      [/Akceptuję/g, 'Přijímám'],
      [/Odrzuć/g, 'Odmítnout'],
      [/Polityka prywatności/g, 'zásadách ochrany soukromí'],
      [/[0-9]+ opinii/g, 'ověřená hodnocení'],
      [/OPINII/g, 'HODNOCENÍ'],
      [/WYSYŁKA 24H/g, 'ODESLÁNÍ DO 24 H'],
      [/POLSKI PRODUCENT OD 2014/g, 'CZ · FM OD 2014'],
      [/Varis — lżejszy, bardziej dopasowany profil\. Bezpośrednie czucie piłki\. Dla bramkarzy ceniących szybką reakcję i precyzję\./g, 'Varis je lehčí a přesněji padnoucí profil. Přímý cit pro míč. Pro brankáře, kteří chtějí rychlou reakci a přesnost.'],
      [/Invictus — pełniejszy, większa powierzchnia kontaktu, mocniejsze osadzenie dłoni\. Dla bramkarzy ceniących zabudowę i pewność\./g, 'Invictus má plnější konstrukci, větší kontaktní plochu a pevnější usazení ruky. Pro brankáře, kteří chtějí jistotu a stabilitu.'],
      [/★★★★★ 4,88\/5 · [0-9]+ opinii · zaufało nam już [0-9 ]+\+ bramkarzy/g, '★★★★★ Trusted Shops 4,89/5 · 202 000+ prodaných párů od roku 2014'],
      [/★★★★★ 4,88\/5 · [0-9]+ opinii na TrustedShops/g, '★★★★★ Trusted Shops 4,89/5'],
      [/Pokazujesz dłoń kamerze telefonu\. Skaner wyznacza szerokość i długość dłoni, a potem prowadzi do rozmiaru i modelu\. Koniec zgadywania przed zakupem\./g, 'Ukážeš ruku kameře v telefonu. Skener určí šířku a délku ruky a navede tě k velikosti a modelu. Konec hádání před nákupem.'],
      [/Najpierw rękawica i rozmiar\. Potem opinie, historia marki od 2014 roku i wyróżnienia jakości, które realnie budują zaufanie przed zakupem\./g, 'Nejdřív rukavice a velikost. Potom hodnocení, historie značky od roku 2014 a důvody, které pomáhají rozhodnout se před nákupem.'],
      [/Rękawice są zrobione pod realne bronienie: chwyt, dopasowanie i kontrolę\. Bez przepłacania za sam znaczek i bez zgadywania rozmiaru\./g, 'Rukavice jsou navržené pro skutečné chytání: grip, střih a kontrolu. Bez přeplácení jen za logo a bez hádání velikosti.'],
      [/Wybierasz nie tylko kolor, ale krój, stabilizację dłoni, przeznaczenie i rozmiar\. Każdy wariant ma prowadzić do decyzji zakupowej\./g, 'Nevybíráš jen barvu, ale střih, stabilitu ruky, použití a velikost. Každý detail má pomoct s nákupním rozhodnutím.'],
      [/Football Masters działa od 2014 roku\. Sklep ma pomagać bramkarzowi wybrać właściwy model, rozmiar i wariant bez rozmowy z botem albo przekopywania się przez techniczne opisy\./g, 'Football Masters funguje od roku 2014. Obchod má brankáři pomoct vybrat správný model, velikost a variantu bez složitých technických popisů.'],
      [/Sklep prowadzi do zakupu pojedynczych par, a kontakt mailowy obsługuje zapytania klubowe i większe zamówienia\./g, 'Obchod vede k nákupu jednotlivých párů a kontaktní formulář řeší klubové dotazy nebo větší objednávky.'],
      [/JDG · NIP 5272592477 · Aleja Krakowska 29, 05-090 Janki · marka rozwijana od 2014 roku\./g, 'JDG · NIP 5272592477 · Aleja Krakowska 29, 05-090 Janki, Polsko · značka rozvíjená od roku 2014.'],
      [/Dla dłoni ok\. ([0-9,.]+) × ([0-9,.]+) cm rekomendujemy ([^.]+)\. Jeśli jesteś między rozmiarami, napisz przed zakupem\./g, 'Pro ruku cca $1 × $2 cm doporučujeme $3. Pokud jsi mezi velikostmi, napiš před nákupem.'],
      [/Rozmiar ([0-9]+) ·/g, 'Velikost $1 ·'],
      [/Kup ([^·]+) · rozmiar ([0-9]+)/g, 'Koupit $1 · velikost $2']
    ];

    function translateText(value) {
      var trimmed = value.trim();
      var next = exact[trimmed] ? value.replace(trimmed, exact[trimmed]) : value;
      patterns.forEach(function (entry) {
        next = next.replace(entry[0], entry[1]);
      });
      return next;
    }

    var walker = document.createTreeWalker(document.body || document.documentElement, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var text = node.nodeValue;
      var translated = translateText(text);
      if (translated !== text) node.nodeValue = translated;
    }

    document.querySelectorAll('[aria-label], [title], [alt]').forEach(function (element) {
      ['aria-label', 'title', 'alt'].forEach(function (attr) {
        var value = element.getAttribute && element.getAttribute(attr);
        if (!value) return;
        var translated = translateText(value);
        if (translated !== value) element.setAttribute(attr, translated);
      });
    });

    var currentLang = document.querySelector('.fm-lang-switcher summary');
    var currentLangHtml = '<span>🇨🇿</span><span>Čeština</span>';
    if (currentLang && currentLang.innerHTML !== currentLangHtml) currentLang.innerHTML = currentLangHtml;

    document.querySelectorAll('.fm-trust-strip--home').forEach(function (strip) {
      strip.style.width = 'min(1540px, calc(100vw - 72px))';
      strip.style.maxWidth = 'calc(100vw - 72px)';
      strip.style.marginLeft = 'auto';
      strip.style.marginRight = 'auto';
    });

    document.querySelectorAll('a[href="/?view=cs"]').forEach(function (link) {
      if (!link.href.includes('view=cs')) link.href = '/?view=cs';
    });
  }

  function cleanProductCopy() {
    var body = document.body;
    if (!body) return;
    var localizedStorefront = previewLocale() === 'cs' || previewLocale() === 'sk';

    var replacements = localizedStorefront ? [] : [
      [/Cena i warianty przeniesione z aktualnego katalogu FM Pro \/ IdoSell\./gi, 'Wybierz rozmiar przed dodaniem do koszyka.'],
      [/realna dostępność/gi, 'dostępność rozmiaru'],
      [/Realny stock/gi, 'Dostępność rozmiaru'],
      [/użyj skanera/gi, 'skaner dłoni'],
      [/zastosowanie\s*match/gi, 'zastosowanie mecz'],
      [/(\d+)\s*szt\./gi, function (_, n) { return stockLabel(n); }],
      [/Buy it now/gi, 'Kup teraz'],
      [/30 dni zwrot/gi, '14 dni zwrot'],
      [/TrustedShops/gi, 'opinie klientów'],
      [/Football Masters Wojciech Małecki · Janki koło Warszawy/gi, 'Football Masters od 2014'],
      [/w\.malecki@footballmasters\.pl/gi, 'formularz kontaktowy'],
      [/checkoutu Shopify/gi, 'finalizacji zamówienia'],
      [/standardowy proces Shopify/gi, 'bezpieczny proces sklepu'],
      [/To ma wyglądać jak FM Pro: najpierw produkt, potem dowód, że za rękawicą stoi marka od 2014 roku, opinie klientów i wyróżnienia jakości\./gi, 'Najpierw rękawica i rozmiar. Potem opinie klientów, historia marki od 2014 roku i jasne warunki zakupu.']
    ];

    var walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var text = node.nodeValue;
      var next = text;
      replacements.forEach(function (entry) {
        next = next.replace(entry[0], entry[1]);
      });
      if (next !== text) node.nodeValue = next;
    }

    document.querySelectorAll('select[name="id"] option').forEach(function (option) {
      option.textContent = (option.textContent || '').replace(/(\d+)\s*szt\./gi, function (_, n) {
        return stockLabel(n);
      });
    });

    function syncSelectedVariant(select) {
      if (!select) return;
      var selectedOption = select.options[select.selectedIndex];
      var selectedValue = select.value;
      document.querySelectorAll('[data-fm-variant-id]').forEach(function (item) {
        item.classList.toggle('is-selected', item.dataset.fmVariantId === selectedValue);
      });
      document.querySelectorAll('[data-add-to-cart]').forEach(function (submit) {
        var price = selectedOption && selectedOption.dataset ? selectedOption.dataset.priceLabel : '';
        var label = submit.dataset.fmAddLabel || (localePrefix === '/cs' ? 'Přidat do košíku' : (localePrefix === '/sk' ? 'Pridať do košíka' : 'Dodaj do koszyka'));
        if (price) submit.value = label + ' · ' + price;
      });
      document.querySelectorAll('[data-fm-sticky-variant]').forEach(function (stickySelect) {
        stickySelect.value = selectedValue;
      });
    }

    document.querySelectorAll('select[name="id"]').forEach(function (select) {
      if (!select.dataset.fmVariantSelectBound) {
        select.dataset.fmVariantSelectBound = '1';
        select.addEventListener('change', function () {
          syncSelectedVariant(select);
        });
      }
      syncSelectedVariant(select);
    });

    document.querySelectorAll('[data-fm-variant-id]').forEach(function (button) {
      if (button.dataset.fmVariantBound) return;
      button.dataset.fmVariantBound = '1';
      button.addEventListener('click', function () {
        if (button.disabled) return;
        var select = document.querySelector('select[name="id"]');
        if (!select) return;
        select.value = button.dataset.fmVariantId;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    document.querySelectorAll('[data-fm-gallery-src]').forEach(function (button) {
      if (button.dataset.fmGalleryBound) return;
      button.dataset.fmGalleryBound = '1';
      button.addEventListener('click', function () {
        var img = document.querySelector('.fm-gallery-main-image');
        var src = button.dataset.fmGallerySrc;
        if (!img || !src) return;
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = src;
        var label = document.querySelector('.fm-shot-label');
        if (label && button.dataset.fmGalleryLabel) {
          label.textContent = button.dataset.fmGalleryLabel;
        }
        document.querySelectorAll('[data-fm-gallery-src]').forEach(function (item) {
          item.classList.toggle('is-active', item === button);
        });
      });
    });

    document.querySelectorAll('[data-fm-sticky-variant]').forEach(function (stickySelect) {
      if (!stickySelect.dataset.fmStickyVariantBound) {
        stickySelect.dataset.fmStickyVariantBound = '1';
        stickySelect.addEventListener('change', function () {
          var select = document.querySelector('select[name="id"]');
          if (!select) return;
          select.value = stickySelect.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    });

    document.querySelectorAll('[data-fm-sticky-submit]').forEach(function (button) {
      if (button.dataset.fmStickySubmitBound) return;
      button.dataset.fmStickySubmitBound = '1';
      button.addEventListener('click', function () {
        var form = document.querySelector('.fm-product-form form[action*="/cart/add"], form[action*="/cart/add"]');
        var select = document.querySelector('select[name="id"]');
        var stickySelect = document.querySelector('[data-fm-sticky-variant]');
        if (select && stickySelect) {
          select.value = stickySelect.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (!form) return;
        var submit = form.querySelector('[data-add-to-cart], button[type="submit"], input[type="submit"]');
        if (form.requestSubmit && submit) form.requestSubmit(submit);
        else form.submit();
      });
    });

    if (!document.documentElement.dataset.fmStickyVisibilityBound) {
      document.documentElement.dataset.fmStickyVisibilityBound = '1';
      var updateStickyVisibility = function () {
        var form = document.querySelector('.fm-product-form');
        var formTop = form ? form.getBoundingClientRect().top : 0;
        var visible = window.scrollY > 520 || (form && formTop < -80);
        document.body.classList.toggle('fm-sticky-atc-visible', Boolean(visible));
      };
      window.addEventListener('scroll', updateStickyVisibility, { passive: true });
      window.addEventListener('resize', updateStickyVisibility);
      updateStickyVisibility();
    }

    document.querySelectorAll('.shopify-payment-button__button').forEach(function (button) {
      if (/buy it now/i.test(button.textContent || '')) button.textContent = 'Kup teraz';
    });

    document.querySelectorAll('[data-fm-buy-now]').forEach(function (button) {
      if (button.dataset.fmBuyNowBound) return;
      button.dataset.fmBuyNowBound = '1';
      button.addEventListener('click', function () {
        var form = button.closest('form');
        if (!form) return;
        var returnTo = form.querySelector('input[name="return_to"]');
        if (!returnTo) {
          returnTo = document.createElement('input');
          returnTo.type = 'hidden';
          returnTo.name = 'return_to';
          form.appendChild(returnTo);
        }
        returnTo.value = localePrefix ? localePrefix + '/checkout' : '/checkout';
        form.submit();
      });
    });

    document.querySelectorAll('a[href^="mailto:w.malecki@footballmasters.pl"]').forEach(function (link) {
      link.href = '/pages/kontakt';
      if (/w\.malecki@footballmasters\.pl|mail|wyślij|zapytanie/i.test(link.textContent || '')) {
        link.textContent = 'Formularz kontaktowy';
      }
    });

    document.querySelectorAll('a[href="/account"], a[href$="/account"]').forEach(function (link) {
      if (!link.getAttribute('aria-label') && !(link.textContent || '').trim()) {
        link.setAttribute('aria-label', previewLocale() === 'cs' ? 'Můj účet' : (previewLocale() === 'sk' ? 'Môj účet' : 'Moje konto'));
      }
    });

    document.querySelectorAll('a[href="#size-guide"], a[href$="#size-guide"]').forEach(function (link) {
      if (link.dataset.fmSizeGuideBound) return;
      link.dataset.fmSizeGuideBound = '1';
      link.addEventListener('click', function (event) {
        var target = document.getElementById('size-guide');
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (window.history && window.history.replaceState) {
          window.history.replaceState(window.history.state, document.title, '#size-guide');
        }
      });
    });

    document.querySelectorAll('a[href$="#hand-scanner"]').forEach(function (link) {
      if (document.getElementById('hand-scanner')) return;
      link.href = marketScannerUrl('#size-guide');
    });
  }

  function ensureScannerQr() {
    if (!/\/(pomiar|pages\/pomiar|pages\/skaner-dloni-fm-pro|pages\/skaner-dloni-live)\/?$/i.test(path)) return;
    var instructionCard = document.querySelector('.fm-pomiar-page .instruction-card, .instruction-card');
    if (!instructionCard) return;
    var targetUrl = marketScannerUrl('');
    var existingImg = instructionCard.querySelector('.scanner-qr-card img');
    if (existingImg) {
      existingImg.src = qrImageUrl(targetUrl);
      existingImg.alt = previewLocale() === 'sk' ? 'QR kód ku skeneru dlane Football Masters' : (previewLocale() === 'cs' ? 'QR kód ke skeneru dlaně Football Masters' : 'Kod QR do skanera dłoni Football Masters');
      existingImg.setAttribute('data-fm-scanner-target', targetUrl);
      return;
    }
    instructionCard.insertAdjacentHTML('beforeend', [
      '<div class="scanner-qr-card">',
      '<img loading="lazy" decoding="async" src="' + qrImageUrl(targetUrl) + '" alt="Kod QR do skanera dłoni Football Masters" width="132" height="132" data-fm-scanner-target="' + targetUrl + '">',
      '<div><span>Skanujesz z komputera?</span><strong>Otwórz skaner w telefonie</strong><p>Zeskanuj kod QR i uruchom kamerę bez przepisywania adresu.</p></div>',
      '</div>'
    ].join(''));
  }

  function ensureHeroVideos() {
    document.querySelectorAll('video[data-fm-hero-video], .fm-hero-card video').forEach(function (video) {
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.autoplay = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('loop', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      if (!video.getAttribute('preload')) video.setAttribute('preload', 'auto');

      if (!video.dataset.fmHeroVideoBound) {
        video.dataset.fmHeroVideoBound = '1';
        video.addEventListener('pause', function () {
          if (!document.hidden) window.setTimeout(function () { tryPlayHeroVideo(video); }, 180);
        });
        ['loadedmetadata', 'loadeddata', 'canplay', 'stalled', 'suspend'].forEach(function (eventName) {
          video.addEventListener(eventName, function () { tryPlayHeroVideo(video); }, { passive: true });
        });
        ['playing', 'timeupdate', 'loadeddata', 'canplay'].forEach(function (eventName) {
          video.addEventListener(eventName, function () { clearHeroVideoFallback(video); }, { passive: true });
        });
      }

      if (!video.currentSrc && video.querySelector('source[src]') && !video.dataset.fmHeroLoadAttempted) {
        video.dataset.fmHeroLoadAttempted = '1';
        try { video.load(); } catch (error) {}
      }
      tryPlayHeroVideo(video);
      scheduleHeroVideoFallback(video);
    });
  }

  function tryPlayHeroVideo(video) {
    if (!video || document.hidden) return;
    if (video.readyState === 0 && video.querySelector('source[src]') && !video.dataset.fmHeroLoadAttempted) {
      video.dataset.fmHeroLoadAttempted = '1';
      try { video.load(); } catch (error) {}
    }
    try {
      var playPromise = video.play();
      if (playPromise && playPromise.then) {
        playPromise.then(function () { clearHeroVideoFallback(video); }).catch(function () {
          window.setTimeout(function () {
            if (!document.hidden) {
              try { video.play(); } catch (error) {}
            }
          }, 450);
        });
      } else if (playPromise && playPromise.catch) {
        playPromise.catch(function () {
          window.setTimeout(function () {
            if (!document.hidden) {
              try { video.play(); } catch (error) {}
            }
          }, 450);
        });
      }
    } catch (error) {}
  }

  function scheduleHeroVideoFallback(video) {
    if (!video || video.dataset.fmHeroFallbackScheduled) return;
    video.dataset.fmHeroFallbackScheduled = '1';
    [2600, 6200].forEach(function (delay) {
      window.setTimeout(function () { verifyHeroVideoMotion(video); }, delay);
    });
  }

  function verifyHeroVideoMotion(video) {
    if (!video || document.hidden) return;
    if (video.readyState >= 2 && video.currentTime > 0.15) {
      clearHeroVideoFallback(video);
      return;
    }
    tryPlayHeroVideo(video);
    window.setTimeout(function () {
      if (!video || document.hidden) return;
      if (video.readyState >= 2 && video.currentTime > 0.15) {
        clearHeroVideoFallback(video);
        return;
      }
      var card = video.closest('.fm-hero-card');
      var poster = video.getAttribute('poster');
      if (!card || !poster) return;
      card.style.setProperty('--fm-video-poster', 'url("' + poster.replace(/["\\]/g, '\\$&') + '")');
      card.classList.add('fm-hero-card--video-fallback');
    }, 650);
  }

  function clearHeroVideoFallback(video) {
    if (!video || video.readyState < 2 || video.currentTime <= 0.15) return;
    var card = video.closest('.fm-hero-card');
    if (!card) return;
    card.classList.remove('fm-hero-card--video-fallback');
    card.style.removeProperty('--fm-video-poster');
  }

  function replayScripts(root) {
    if (!root) return;
    root.querySelectorAll('script').forEach(function (oldScript) {
      var nextScript = document.createElement('script');
      Array.from(oldScript.attributes).forEach(function (attr) {
        nextScript.setAttribute(attr.name, attr.value);
      });
      nextScript.text = oldScript.textContent;
      oldScript.replaceWith(nextScript);
    });
  }

  function rescueCachedHome() {
    if (!/^\/(?:index\.html)?$/i.test(path)) return;
    if (localePrefix === '/cs' || localePrefix === '/sk') return;
    if (window.__fmHome1to1RescueDone || window.__fmHome1to1RescuePending) return;

    var main = document.getElementById('MainContent');
    if (!main) return;

    var html = main.innerHTML || '';
    var text = main.textContent || '';
    var isStale = html.indexOf('fm_home_launch_excellence_20260516_cache_rebuild') !== -1 ||
      /Sprawdź rękawice|Skaner rozmiaru|Football Masters\s*·\s*od 2014/i.test(text);
    var hasFreshHome = html.indexOf('data-fm-size-shop-link') !== -1 &&
      text.indexOf('200 000+') !== -1 &&
      text.indexOf('Skaner dłoni') !== -1;

    if (!isStale || hasFreshHome) return;

    window.__fmHome1to1RescuePending = true;
    fetch(localeRoot + '?section_id=fm-home-v2&fmHome1to1Rescue=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('FM home 1:1 section load failed');
        return response.text();
      })
      .then(function (sectionHtml) {
        if (!sectionHtml ||
          sectionHtml.indexOf('data-fm-size-shop-link') === -1 ||
          sectionHtml.indexOf('200 000+') === -1 ||
          sectionHtml.indexOf('Skaner dłoni') === -1) {
          throw new Error('FM home 1:1 section markers missing');
        }

        main.innerHTML = sectionHtml;
        replayScripts(main);
        cleanProductCopy();
        ensureHeroVideos();
        applyPreviewLocale();
        window.__fmHome1to1RescueDone = true;

        if (window.location.hash) {
          var target = document.querySelector(window.location.hash);
          if (target) target.scrollIntoView();
        }
      })
      .catch(function () {})
      .finally(function () {
        window.__fmHome1to1RescuePending = false;
      });
  }

  function normalizeViewLanding() {
    if (!/^\/(?:index\.html)?$/i.test(path)) return;

    document.querySelectorAll('a[href^="/?view=#"]').forEach(function (link) {
      link.setAttribute('href', link.getAttribute('href').replace('/?view=#', '/#'));
    });

    var url = new URL(window.location.href);
    if (!url.searchParams.has('view')) return;
    if (url.searchParams.get('view')) return;
    var next = window.location.pathname || '/';
    if (window.location.hash) next += window.location.hash;
    window.history.replaceState(window.history.state, document.title, next);
  }

  function cleanStorefront() {
    normalizeViewLanding();
    cleanProductCopy();
    ensureScannerQr();
    ensureHeroVideos();
    applyPreviewLocale();
    rescueCachedHome();
    if (window.FMStorefrontLocalizationRun) {
      window.setTimeout(window.FMStorefrontLocalizationRun, 0);
      window.setTimeout(window.FMStorefrontLocalizationRun, 300);
      window.setTimeout(window.FMStorefrontLocalizationRun, 1200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanStorefront);
  } else {
    cleanStorefront();
  }
  window.addEventListener('load', cleanStorefront);
  window.addEventListener('focus', ensureHeroVideos);
  document.addEventListener('visibilitychange', ensureHeroVideos);
  window.setTimeout(cleanStorefront, 600);
  window.setTimeout(cleanStorefront, 1800);
  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.setTimeout(function () {
        pending = false;
        cleanStorefront();
      }, 80);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
